<template>
    <div class="countdown-container">
        <h3 class="title">距离<span v-if="targetTime === 12">中午12点</span><span v-else>下午18点</span>还有：</h3>
        <div class="time-display" :class="{ 'warning': isWarning }">
            <div class="time-unit">
                <span class="time-value">{{ hours }}</span>
                <span class="time-label">小时</span>
            </div>
            <div class="separator">:</div>
            <div class="time-unit">
                <span class="time-value">{{ minutes }}</span>
                <span class="time-label">分钟</span>
            </div>
            <div class="separator">:</div>
            <div class="time-unit">
                <span class="time-value">{{ seconds }}</span>
                <span class="time-label">秒</span>
            </div>
        </div>
        <div class="status-message" v-if="isAfterTarget">
            <span class="celebration">🎉 已经过了<span v-if="targetTime === 12">中午12点</span><span
                    v-else>下午18点</span>！</span>
        </div>
        <div class="warning-message" v-if="warningText">
            <span class="warning-text">{{ warningText }}</span>
        </div>
        <button v-if="showPermissionButton" @click="requestNotificationPermission" class="permission-button">
            允许通知提醒
        </button>
    </div>
</template>

<script>
export default {
    name: "CountdownToTarget",
    data() {
        return {
            hours: "00",
            minutes: "00",
            seconds: "00",
            isAfterTarget: false,
            timer: null,
            targetTime: 12,
            warningText: "",
            isWarning: false,
            warnedMinutes: [],
            showPermissionButton: false
        };
    },
    mounted() {
        this.checkNotificationPermission();
        this.updateCountdown();
        this.timer = setInterval(() => {
            this.updateCountdown();
        }, 1000);
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    methods: {
        checkNotificationPermission() {
            // 检查浏览器是否支持通知API
            if (!('Notification' in window)) {
                console.log('此浏览器不支持桌面通知');
            } else if (Notification.permission === 'granted') {
                // 已获得权限
                console.log('已获得通知权限');
            } else if (Notification.permission !== 'denied') {
                // 未拒绝权限，显示请求按钮
                this.showPermissionButton = true;
            }
        },
        requestNotificationPermission() {
            Notification.requestPermission().then(permission => {
                if (permission === 'granted') {
                    console.log('通知权限已授予');
                    this.showPermissionButton = false;
                } else {
                    console.log('通知权限被拒绝');
                    this.showPermissionButton = false;
                }
            });
        },
        showNotification(message) {
            if (Notification.permission === 'granted') {
                new Notification('倒计时提醒', {
                    body: message,
                    // icon: 'https://image.yueheji.com/CaiHuaProdCache/admin/upload/20250514/20250514175833_3833.png'
                });
            }
        },
        updateCountdown() {
            const now = new Date();
            const currentHours = now.getHours();
            // const currentMinutes = now.getMinutes();
            // const currentSeconds = now.getSeconds();

            // 如果当前时间超过12点，自动切换目标时间为18点
            if (currentHours >= 12) {
                this.targetTime = 18;
            }

            // 获取目标时间的Date对象
            const targetDate = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate(),
                this.targetTime,
                0,
                0
            );

            // 如果当前时间已经超过今天的目标时间，计算到明天目标时间的倒计时
            if (now > targetDate) {
                targetDate.setDate(targetDate.getDate() + 1);
            }

            // 计算剩余时间（毫秒）
            const diff = targetDate - now;

            if (diff > 0) {
                // 计算时、分、秒
                const totalSeconds = Math.floor(diff / 1000);
                const hours = Math.floor(totalSeconds / 3600);
                const minutes = Math.floor((totalSeconds % 3600) / 60);
                const seconds = totalSeconds % 60;

                this.hours = hours.toString().padStart(2, "0");
                this.minutes = minutes.toString().padStart(2, "0");
                this.seconds = seconds.toString().padStart(2, "0");
                this.isAfterTarget = false;

                // 检查是否需要显示警告
                this.checkWarnings(minutes, seconds);
            } else {
                // 时间已过
                this.hours = "00";
                this.minutes = "00";
                this.seconds = "00";
                this.isAfterTarget = true;
                clearInterval(this.timer);
            }
        },
        checkWarnings(minutes, seconds) {
            // 重置警告状态
            this.warningText = "";
            this.isWarning = false;

            // 当剩余10分钟或5分钟且秒数为0时触发警告
            if (seconds === 0) {
                if (minutes === 10 && !this.warnedMinutes.includes(10)) {
                    this.warningText = "注意！距离目标时间还有10分钟！";
                    this.isWarning = true;
                    this.warnedMinutes.push(10);
                    this.triggerVisualAlert();
                    this.showNotification("距离" + (this.targetTime === 12 ? "中午12点" : "下午18点") + "还有10分钟！");
                } else if (minutes === 5 && !this.warnedMinutes.includes(5)) {
                    this.warningText = "仅剩5分钟！准备好结束当前工作！";
                    this.isWarning = true;
                    this.warnedMinutes.push(5);
                    this.triggerVisualAlert();
                    this.showNotification("距离" + (this.targetTime === 12 ? "中午12点" : "下午18点") + "仅剩5分钟！");
                }
            }
        },
        triggerVisualAlert() {
            // 闪烁效果
            const timeDisplay = document.querySelector('.time-display');
            if (timeDisplay) {
                timeDisplay.classList.add('alert-flash');
                setTimeout(() => {
                    timeDisplay.classList.remove('alert-flash');
                }, 3000);
            }
        }
    }
};
</script>

<style scoped>
.countdown-container {
    text-align: center;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    max-width: 400px;
    margin: 0 auto;
}

.title {
    font-size: 18px;
    margin-bottom: 15px;
    color: #333;
}

.time-display {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 36px;
    font-weight: bold;
    color: #333;
    transition: all 0.3s ease;
}

.time-display.warning {
    color: #e74c3c;
}

.time-display.alert-flash {
    animation: flash 0.5s ease-in-out 3;
}

@keyframes flash {

    0%,
    100% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.05);
        background-color: #ffebee;
    }
}

.time-unit {
    display: flex;
    flex-direction: column;
    margin: 0 10px;
}

.time-value {
    background-color: #e9ecef;
    padding: 10px;
    border-radius: 4px;
    min-width: 40px;
}

.time-label {
    font-size: 12px;
    color: #666;
    margin-top: 5px;
}

.separator {
    margin: 0 5px;
}

.status-message {
    margin-top: 15px;
    font-size: 16px;
}

.celebration {
    color: #28a745;
    font-weight: bold;
}

.warning-message {
    margin-top: 10px;
    padding: 8px 12px;
    background-color: #ffebee;
    border-radius: 4px;
    display: inline-block;
}

.warning-text {
    color: #e74c3c;
    font-weight: bold;
}

.permission-button {
    margin-top: 15px;
    padding: 8px 16px;
    background-color: #3498db;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.2s;
}

.permission-button:hover {
    background-color: #2980b9;
}
</style>